import './index.css';

const FormInput = ({ 
  classInput = '',
  label= '',
  placeholder = '',
  required = false,
  disabled = false,
  value,
  isError = false,
  onChange,
  onBlur
}) => {
  return (
    <div className={classInput + ' pt-4'}>
        <div className="row">
          <label className='form_label' htmlFor="">{label} {required == true && <span style={{color: 'red'}}>*</span> }</label>
          <input 
            className= {isError ? 'form_input col-12 is_error' : 'form_input col-12 '}
            type="text"
            placeholder={placeholder}
            disabled={disabled ? 'disabled' : ''}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
          />
        </div>
    </div>
  );
}

export default FormInput;